/**
 * Helper to determine if a module should use mock data based on ENV flags.
 */

/**
 * Resolve um flag de módulo: se a var dedicada for definida explicitamente, ela manda
 * (permite apontar UM módulo pro backend real mesmo com o app em mock); senão, herda
 * do flag geral VITE_MOCK_AGENCY.
 */
function moduleMock(explicit: string | undefined): boolean {
  if (explicit === 'true') return true;
  if (explicit === 'false') return false;
  return import.meta.env.VITE_MOCK_AGENCY === 'true';
}

export const mockFlags = {
  agency: import.meta.env.VITE_MOCK_AGENCY === 'true',
  auth: import.meta.env.VITE_MOCK_AUTH === 'true' || import.meta.env.VITE_MOCK_AGENCY === 'true',
  notifications:
    import.meta.env.VITE_MOCK_NOTIFICATIONS === 'true' ||
    import.meta.env.VITE_MOCK_AGENCY === 'true',
  // Suporte tem flag dedicado: dá pra subir o agency-api e testar SÓ o suporte real
  // (VITE_MOCK_SUPPORT=false) mantendo o resto do app mockado.
  support: moduleMock(import.meta.env.VITE_MOCK_SUPPORT),
  // "Minha assinatura" (hub#138): mock-first até o agency-api expor /me/subscription.
  subscription: moduleMock(import.meta.env.VITE_MOCK_SUBSCRIPTION),
} as const;

export type ModuleName = keyof typeof mockFlags;

export function isMockEnabled(moduleName: ModuleName): boolean {
  return mockFlags[moduleName];
}

export function listActiveMocks(): ModuleName[] {
  return (Object.keys(mockFlags) as ModuleName[]).filter((m) => mockFlags[m]);
}

export function hasAnyMock(): boolean {
  return listActiveMocks().length > 0;
}
